export interface TimelineItemData {
    title: string;
    folder: string;
    from?: string;
    preview?: string;
    isLink?: boolean;
    link?: string;
}

export interface TimelineEntry {
    date: string;
    relativeTime: string;
    count: number;
    type: 'email' | 'file';
    items: TimelineItemData[];
}

export interface FolderData {
    id: string;
    name: string;
    children: FolderData[];
}

export const FOLDER_CATEGORIES = [
    {
        label: 'New deal',
        color: '#3b82f6',
        rootFolderName: 'Company folder',
        rootFolderHint: 'will use the company name',
    },
    {
        label: 'Company update',
        color: '#f59e0b',
        rootFolderName: 'Company folder',
        rootFolderHint: 'will use the company name',
    },
    {
        label: 'New fund opportunity',
        color: '#22c55e',
        rootFolderName: 'Fund folder',
        rootFolderHint: 'will use the fund name',
    },
    {
        label: 'Shared pipeline',
        color: '#7c3aed',
        rootFolderName: 'Company folder',
        rootFolderHint: 'will use the company name',
    },
] as const;

export interface Tab {
    id: string;
    label: string;
}

export interface TabContent {
    sectionTitle: string;
    sectionCount: string;
    entries: TimelineEntry[];
}
